/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState } from "react";

import { Row, Col, InputGroup, Form, Button } from "react-bootstrap";



export default function EditAccountPane(props) {
  const [desc, setDesc] = useState(props.modelAcct.desc);
  const [balance, setBalance] = useState(props.modelAcct.balance);
  const [interest, setInterest] = useState(props.modelAcct.interest);
  const [limit, setLimit] = useState(props.modelAcct.limit);
  const [threshold, setThreshold] = useState(props.modelAcct.threshold);
  const [lastUpdated, setlastUpdated] = useState(props.modelAcct.lastUpdated);

  const [validated, setValidated] = useState(false); //???


  function onDescChanged(event) {
    event.preventDefault();

    setDesc(event.target.value);
  }

  function onBalanceChanged(event) {
    event.preventDefault();

    setBalance(event.target.value); // TODO validate/regex ?
    setlastUpdated(new Date());
  }

  function onInterestChanged(event) {
    event.preventDefault();

    setInterest(event.target.value); // TODO validate/regex ?
  }

  function onLimitChanged(event) {
    event.preventDefault();

    setLimit(event.target.value); // TODO validate/regex ?
  }

  function onThresholdChanged(event) {
    event.preventDefault();

    setThreshold(event.target.value); // TODO validate/regex ?
  }


  function onSubmit(event) {
    event.preventDefault();

    let obj = {
      desc,
      balance,
      interest,
      limit,
      threshold,
      lastUpdated
    };

    let action = {
      type: props.actionType,
      acct: { ...props.modelAcct, ...obj }
    }

    props.onSubmit(action);
  }

  function onCancel(event) {
    event.preventDefault();

    props.onCancel();
  }



  return (
    <>
      <h2>Edit Account</h2>

      <Form noValidate validated={validated} onSubmit={onSubmit}>

        <Form.Group as={Row} className="mb-3" controlId="desc">
          <Col xs={3}>
            <Form.Label >Description</Form.Label>
          </Col>
          <Col xs={5} sm={3}>
            <Form.Control type="text" required value={desc} onChange={onDescChanged} />
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="mb-3" controlId="bal">
          <Col xs={3}>
            <Form.Label >Balance</Form.Label>
          </Col>
          <Col xs={5} sm={3}>
            <InputGroup>
              <Form.Control type="text" required value={balance} onChange={onBalanceChanged} />
              <InputGroup.Text>$</InputGroup.Text>
            </InputGroup>
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="mb-3" controlId="int">
          <Col xs={3}>
            <Form.Label column xs={3}>Interest</Form.Label>
          </Col>
          <Col xs={5} sm={3}>
            <InputGroup>
              <Form.Control type="text" required value={interest} onChange={onInterestChanged} />
              <InputGroup.Text>%</InputGroup.Text>
            </InputGroup>
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="mb-3" controlId="int">
          <Col xs={3}>
            <Form.Label column xs={3}>Limit</Form.Label>
          </Col>
          <Col xs={5} sm={3}>
            <InputGroup>
              <Form.Control type="text" required value={limit} onChange={onLimitChanged} />
              <InputGroup.Text>%</InputGroup.Text>
            </InputGroup>
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="mb-3" controlId="int">
          <Col xs={3}>
            <Form.Label column xs={3}>Threshold</Form.Label>
          </Col>
          <Col xs={5} sm={3}>
            <InputGroup>
              <Form.Control type="text" required value={threshold} onChange={onThresholdChanged} />
              <InputGroup.Text>%</InputGroup.Text>
            </InputGroup>
          </Col>
        </Form.Group>


        <div className="d-grid ">
          <Button variant="primary" type="submit" >Update</Button>
          <Button variant="secondary" type="button" onClick={onCancel}>Cancel</Button>
        </div>

      </Form>

    </>
  );
}

